module.exports = __webpack_public_path__ + "img/zhengshu.573cd813.png";